import { render } from "./TeltonikaDecoder.vue?vue&type=template&id=2ddc23d2&scoped=true"
import script from "./TeltonikaDecoder.vue?vue&type=script&lang=js"
export * from "./TeltonikaDecoder.vue?vue&type=script&lang=js"

import "./TeltonikaDecoder.vue?vue&type=style&index=0&id=2ddc23d2&scoped=true&lang=scss"

import exportComponent from "/opt/tracking-bg-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ddc23d2"]])

export default __exports__